import React, { createContext, useContext, useState, useEffect } from 'react';
import { onAuthStateChange, isAuthorizedUser } from '../services/authService';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChange(async (user) => {
      setUser(user);

      if (user) {
        setIsAuthenticated(true);
        try {
          const authorized = await isAuthorizedUser(user);
          setIsAuthorized(authorized);
        } catch (error) {
          console.error('Error checking authorization:', error);
          setIsAuthorized(false);
        }
      } else {
        setIsAuthenticated(false);
        setIsAuthorized(false);
      }

      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const value = {
    user,
    isAuthenticated,
    isAuthorized,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};